/* eslint-disable import/prefer-default-export */
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { getHeightStickyOnTop } from "./utils";
import { gsap } from "gsap";

gsap.registerPlugin(ScrollToPlugin);

const getScrollTopElement = (el: HTMLElement) => {
  const elRect = el.getBoundingClientRect();
  const heightStickyOnTop = getHeightStickyOnTop();
  return elRect.top + window.scrollY - heightStickyOnTop;
};

type ScrollToPropsId = {
  value: string;
  type: "id";
};

type ScrollToPropsNode = {
  value: HTMLElement;
  type: "node";
};

type ScrollToPropsValue = {
  value: number;
  type: "value";
};

type ScrollToProps = ScrollToPropsId | ScrollToPropsNode | ScrollToPropsValue;

// TODO : add on ScrollSectionItem with new {} param and test
export const scrollTo = (data: ScrollToProps) => {
  let top = 0;
  switch (data.type) {
    case "id": {
      const el = document.getElementById(data.value);
      if (el) {
        top = getScrollTopElement(el);
      }
      break;
    }
    case "node":
      top = getScrollTopElement(data.value);
      break;
    default:
      top = data.value;
  }
  gsap.to(window, { scrollTo: top, duration: 0.5 });
};
